import $api from "@/core/services/ApiService";
import { AxiosResponse } from "axios";

class WhiteLabelFrontEndEndpoint {
  public view(): Promise<AxiosResponse> {
    return $api.get(`white-label`);
  }
}

export default WhiteLabelFrontEndEndpoint;
